import { styled } from '@linaria/react';

export const NeuronsCost = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	column-gap: 8px;
	margin-top: auto;
	margin-bottom: 16px;
	padding: 0 14px;
	width: fit-content;
	height: 34px;
	color: var(--color-white) !important;
	background: var(--color-black-05);
	border-radius: 18px;
`;
